/* global Landbot */

import React from 'react';
import {useEffect, useRef} from 'react';

// // import refreshPage from './getScreen';
// // import { logError } from './error';

// function sleep(ms) {
//   return new Promise((resolve) => {
//     setTimeout(resolve, ms);
//   });
// } 

// async function waitForLandbot(){
//   if(Landbot) return;
//   await sleep(500);
//   return await waitForLandbot();
// }

// export default async function loadLandbot(configUrl, customData = {}){
//   await waitForLandbot();
  
// //   try {
//     const myLandbot = new Landbot.Container({
//       container: '#myLandbot',
//       configUrl,
//       customData
//     });
  
//     return myLandbot;

// //   } catch (error){
// //     logError(error);
// //     refreshPage();
// //   }

// }

export default function LoadLandbot({ url, event, customData = {} , showChatbot = true}) {
  const containerRef = useRef(null);

  useEffect(() => {
    const _landbot = new Landbot.Container({
      container: containerRef.current,
      configUrl: url,
      customData
    });

    return () => _landbot.destroy();
  }, [url, containerRef, customData]);

  window.landbotevent = event;

  return <div style={{"width": "100%", "height": "100%", display: showChatbot ? "inline" : "none"}} className="MyLandbot" ref={containerRef} />;
}